module.exports = __webpack_public_path__ + "img/machine-code-guide2.def620bb.png";